import { useContext } from 'react'
import mainContext from './MainContext/mainContext'

const useMainContext = () => useContext(mainContext)

export { useMainContext }
